module.exports = __webpack_public_path__ + "nc_static/media/profile_icon.06eb1b55.png";